module.exports = __webpack_public_path__ + "img/Boomfest-6.29-3.1afcfa40.png";